import {
    saveUserSettings,
    userSettings
} from "@/globals/userSettings";
import { LANGUAGES } from "./Languages";
import translateWidget from "@/views/menu/translateWidget";
import { $menu } from "@/views/menu/menu";
import { pluginConfig } from "@/globals/pluginConfig";

export function changeLanguage(newLang, $menu) {
    // Match case-insensitively but normalise to the canonical code. Codes like
    // "zh-Hans"/"zh-Hant" are mixed-case BCP-47 tags; lowercasing them would
    // break the LANGUAGES lookup, the dictionary lookup in t(), and the
    // dropdown's selected state — all of which compare against the canonical code.
    const requested = String(newLang || "").toLowerCase();
    const matched = LANGUAGES.find(lang => lang.code.toLowerCase() === requested);
    newLang = matched ? matched.code : pluginConfig.language.default;

    if (userSettings.lang !== newLang) {
        userSettings.lang = newLang;

        const $lang = $menu.querySelector("#cya11y-language");
        if ($lang) {
            $lang.value = newLang;
        }

        translateWidget($menu);
        saveUserSettings();
    }
}